export function EraserIcon({ size = 15 }: { size?: number } = {}) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <g transform="rotate(-45 12 12)">
        <rect x="3" y="7" width="18" height="10" rx="2"/>
        <line x1="7" y1="7" x2="7" y2="17"/>
      </g>
    </svg>
  )
}
